export const truncateWithEllipsis = (
  label: string,
  maxLength: number
): string =>
  label.length > maxLength ? `${label.substring(0, maxLength)}...` : label;
